// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"596":"5ce21c85","787":"651ff3a4"}[chunkId] + ".chunk.js";
};